import { ContactType } from '../enums/contactType'

export const isPersonContactType = (contactType?: ContactType) => contactType === ContactType.Person
